import { useEffect } from 'react';
import Icon from './Icon';
import './Modal.css';

function Modal({ open, onClose, title, subtitle, icon, size, variant, headerActions, children, footer }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={`modal-overlay${variant ? ` modal-overlay--${variant}` : ''}`} onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className={`modal${size ? ` modal--${size}` : ''}${variant ? ` modal--${variant}` : ''}`}>

        <div className="modal__header">
          <div className="modal__header-left">
            {icon && <div className="modal__header-icon">{icon}</div>}
            <div>
              <div className="modal__title">{title}</div>
              {subtitle && <div className="modal__subtitle">{subtitle}</div>}
            </div>
          </div>
          <div className="modal__header-right">
            {headerActions && <div className="modal__header-actions">{headerActions}</div>}
            <button className="modal__close" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal__body">{children}</div>

        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  message,
  itemName,
  title = 'تأكيد الحذف',
  confirmLabel = 'حذف',
  cancelLabel = 'إلغاء',
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      icon={<Icon name="trash" size={18} color="#fff" />}
      size="sm"
      footer={
        <>
          <button className="btn btn--danger" onClick={onConfirm}><Icon name="trash" size={14} color="#fff" /> {confirmLabel}</button>
          <button className="btn btn--ghost" onClick={onClose}>{cancelLabel}</button>
        </>
      }
    >
      <div className="confirm__icon"><Icon name="warning" size={28} color="#c62828" strokeWidth={1.8} /></div>
      <p className="confirm__msg">
        {message || <>هل أنت متأكد من حذف <strong>{itemName}</strong>؟ لا يمكن التراجع عن هذا الإجراء.</>}
      </p>
    </Modal>
  );
}

export function ArchiveConfirmDialog({
  open,
  onClose,
  onConfirm,
  itemName,
  title,
  confirmLabel,
  cancelLabel,
  loading = false,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title || 'أرشفة'}
      icon={<Icon name="archive" size={18} color="#fff" />}
      variant="archive"
      size="sm"
      footer={
        <>
          <button className="btn btn--archive" onClick={onConfirm} disabled={loading}>
            <Icon name="archive" size={14} color="#fff" /> {confirmLabel || 'أرشفة'}
          </button>
          <button className="btn btn--ghost" onClick={onClose}>{cancelLabel || 'إلغاء'}</button>
        </>
      }
    >
      <div className="confirm__icon confirm__icon--archive">
        <Icon name="archive" size={28} color="#f57f17" strokeWidth={1.8} />
      </div>
      <p className="confirm__msg">
        {itemName
          ? <><strong>{itemName}</strong> — {title || 'سيتم أرشفة هذا العنصر.'}</>
          : (title || 'سيتم أرشفة هذا العنصر.')}
      </p>
      <p className="confirm__hint">{loading ? '…' : ''}</p>
    </Modal>
  );
}

export default Modal;
